import type { FaireReviewEntity } from "../../entity_types/review";

// Real per-product review for Ora Cacao's "Triple Fat Cacao Powder, 100%
// Cacao - Organic & Regenerative" (p_v8h4xykzkx), pulled from Faire's live
// `GET /api/product-reviews/product/{product_token}` endpoint — verbatim
// comment, real reviewer, real rating, real publish date. This product only
// has one real review on the live PDP (`total_product_reviews_count: 1`) —
// included anyway since it is genuine and 5-star, not fabricated.
export const review_oc6: FaireReviewEntity = {
  token: "review_oc6",
  type: "review",
  brandName: "Ora Cacao",
  brandToken: "b_djuc44eyt2",
  productToken: "p_v8h4xykzkx",
  reviewType: "product",
  reviewerName: "Stephanie Dickey",
  reviewerLocation: "Port Townsend, WA, United States",
  stars: 5,
  reviewText: "Now a fave of several!",
  reviewDate: "May 20, 2026",
  meta: {
    source: "api" as const,
    importedAt: "2026-08-11T20:50:10.000Z",
    importedBy: "entity-db-cli",
  },
};
